import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, DrawerStepper } from '@mercai/clever'
import { ProfileConsumptionDrawerProps } from './consumption-drawer.type'
import { ProfileConsumptionForm } from './components'
import { LeadProps } from '@/types'

export const ProfileConsumptionDrawer = ({
  isOpen,
  onHandleOpen,
  onSubmit,
  isLoading = false,
  values,
}: ProfileConsumptionDrawerProps) => {
  const { t } = useTranslation('screenProfileShow')

  const [internalValues, setInternalValues] = useState<Partial<LeadProps>>({
    monthlyBuyingPotential: values?.monthlyBuyingPotential,
    purchaseFrequency: values?.purchaseFrequency,
    companyAge: values?.companyAge,
  })

  useEffect(() => {
    setInternalValues({
      monthlyBuyingPotential: values?.monthlyBuyingPotential,
      purchaseFrequency: values?.purchaseFrequency,
      companyAge: values?.companyAge,
    })

    return () => {
      setInternalValues({})
    }
  }, [values])

  return (
    <DrawerStepper
      translations={{
        optional: '',
      }}
      isOpen={isOpen}
      onHandleOpen={onHandleOpen}
      title={t('consumptionDrawerTitle')}
      initialStep="root"
      steps={{
        root: {
          isOptional: true,
          backNavigate: 'root',
          component: (
            <ProfileConsumptionForm
              values={internalValues}
              onValuesChange={setInternalValues}
            />
          ),
          footer: () => (
            <>
              <Button variant="secondary" onClick={onHandleOpen}>
                {t('backLabel')}
              </Button>
              <Button
                onClick={() => onSubmit?.(internalValues)}
                isActive={!isLoading}
                disabled={isLoading}
              >
                {t('confirmLabel')}
              </Button>
            </>
          ),
        },
      }}
    />
  )
}
